const title =window['pathConfig'][process.env.NODE_ENV].isxunjee? '武汉讯捷·企业微信服务商-定制开发-AI应用':'北京畅邮空间·企业微信服务商-定制开发-AI应用';

export default function getPageTitle(pageTitle) {
  // if (pageTitle) {
  //   return `${pageTitle} - ${title}`;
  // }
  return `${title}`;
}
